import _ from '@luna/lodash';

import { base } from './base';
import { AT } from './AT';
import { CZ } from './CZ';
import { SK } from './SK';
import { RO } from './RO';
import { HU } from './HU';
import { HR } from './HR';
import { RS } from './RS';

export const ownTransferFeaturesMap = {
    base,
    AT: _.merge({}, base, AT),
    CZ: _.merge({}, base, CZ),
    SK: _.merge({}, base, SK),
    RO: _.merge({}, base, RO),
    HU: _.merge({}, base, HU),
    HR: _.merge({}, base, HR),
    RS: _.merge({}, base, RS),
};
